import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: theme?.helpPopup?.headerBackgroundColor,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  dialogTitle: {
    color: theme?.helpPopup?.headerTextColor,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    color: theme?.helpPopup?.closeIconColor,
  },
  icon: {
    color: theme?.helpPopup?.textColor,
    borderRadius: theme.spacing(0.5),
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme?.helpPopup?.textColor,
    padding: theme.spacing(0.4),
  },
  valueTxt: {
    color: theme?.helpPopup?.textColor,
    marginLeft: theme.spacing(1.5),
  },
}));

export default useStyles;
